jQuery.validator.addMethod(
    'phoneMask',
    function(value, element) {
        return this.optional(element) || /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}$/.test(value);
    },
    'Указан неверный телефон'
);

/*jQuery.validator.addMethod("require_from_group", function(value, element, options) {
	var validator = this;
	var selector = options[1];
	var validOrNot = $(selector, element.form).filter(function() {
			return validator.elementValue(this);
		}).length >= options[0];

	if(!$(element).data('being_validated')) {
		var fields = $(selector, element.form);
		fields.data('being_validated', true);
		fields.valid();
		fields.data('being_validated', false);
	}
	return validOrNot;
}, jQuery.validator.format("Заполните как минимум {0} из этих полей."));*/

$.validator.addMethod(
    'require_from_group',
    function(value, element, options) {
        var $fields = $(options[1], element.form),
            $fieldsFirst = $fields.eq(0),
            validator = $fieldsFirst.data('valid_req_grp') ? $fieldsFirst.data('valid_req_grp') : $.extend({}, this),
            isValid =
                $fields.filter(function() {
                    return validator.elementValue(this);
                }).length >= options[0];

        // Store the cloned validator for future validation
        $fieldsFirst.data('valid_req_grp', validator);

        // If element isn't being validated, run each require_from_group field's validation rules
        if (!$(element).data('being_validated')) {
            $fields.data('being_validated', true);
            $fields.each(function() {
                validator.element(this);
            });
            $fields.data('being_validated', false);
        }
        return isValid;
    },
    $.validator.format('Please fill at least {0} of these fields.')
);

$.validator.addMethod(
    'all_req',
    function(value, element, options) {
        var isValid = false;

        var $fields = $(options[0], element.form);
        var count = $fields.length;

        $fields.each(function() {
            if (this.value !== '') {
                count--;
            }
        });

        if (count == 0 || count == $fields.length) isValid = true;
        else if (value !== '') isValid = true;

        return isValid;
    },
    $.validator.format('Заполните либо все, либо ни одного поля')
);

/* Проверка контрольных разрядов ИНН  - используется в методе INN_RUS */
var getControlSum = function(value, position) {
    var res = -1;
    if (position < value.length - 2 || position > 11) {
        return res;
    }
    var test = [2, 4, 10, 3, 5, 9, 4, 6, 8];
    if (position > test.length) {
        test.unshift(7);
    }
    if (position > test.length) {
        test.unshift(3);
    }

    var arr = [];
    for (var i = 0; i < value.length; i++) {
        arr.push(parseInt(value[i]));
    }

    var summ = 0;
    for (i = 0; i < test.length; i++) {
        summ += test[i] * arr[i];
    }

    res = summ % 11;
    res = res % 10;

    if (res === 10) {
        res = 0;
    }

    return res;
};
/* Формат КПП и ИНН в соответствии с Приказом ФНС РФ от 29.06.2012 № ММВ-7-6/435@ */
jQuery.validator.addMethod(
    'KPP_RUS',
    function(value) {
        return /^[\d]{4}[\dA-Z]{2}[\d]{3}$/.test(value) || value === '';
    },
    'Enter valid KPP'
);
jQuery.validator.addMethod(
    'INN_RUS',
    function(value) {
        var res = /^[\d]{10}$/.test(value) || /^[\d]{12}$/.test(value);
        if (!res) {
            return res;
        }

        switch (value.length) {
            case 10:
                res = parseInt(value[9]) === getControlSum(value, 9);
                break;
            case 12:
                res =
                    parseInt(value[10]) === getControlSum(value, 10) &&
                    parseInt(value[11]) === getControlSum(value, 11);
                break;
            default:
                res = false;
                break;
        }

        return res;
    },
    'Enter valid INN'
);



// WEBPACK FOOTER //
// ./blocks/validator.js